import React from 'react';
import { UseFormMethods } from 'react-hook-form';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import ExtensionOption from 'src/models/ExtensionOption';
import IndexReferenceType from 'src/models/IndexReferenceType';
import AgreementUtil from 'src/util/AgreementUtil';

interface IExtensionOptionListProps extends Partial<Pick<UseFormMethods, 'getValues' | 'setValue' | 'register' | 'errors'>> {
    extensionOptions: Array<ExtensionOption>;
    measurementTypes: Array<IndexReferenceType>;
    namePrefix: string;
    isInHanded?: boolean;
    calculateTotals?: boolean;
    netAcres?: number;
    isReadonly?: boolean;

    calculateTotal?: (measurementTypeId: number, paymentAmount: number, grossAcres: number, measurementTypesList: Array<IndexReferenceType>) => void;
}

const ExtensionOptionList = (props: IExtensionOptionListProps) => {
    const handleTotals = (index: number) => {
        if (props.calculateTotals === true) {
            let rep = props.getValues();
            let repReference = rep;
            let sections = props.namePrefix.split('.');
            for (let s of sections) {
                if (s.indexOf('[') > -1) {
                    let arrRef = s.indexOf('[');
                    let arrIndex = parseInt(s.substring(arrRef + 1, s.length - 1), 10);
                    repReference = repReference?.[s.substring(0, arrRef)];
                    repReference = repReference?.[arrIndex];
                } else {
                    repReference = repReference?.[s];
                }
            }
    
            let optionFeeTypeId = parseInt(repReference?.[index]?.optionFeeTypeId, 10);
            let optionAmount = parseFloat(repReference?.[index]?.optionAmount);
            if (!isNaN(optionFeeTypeId) && !isNaN(optionAmount) && props.calculateTotal !== undefined) {
                let totalRent = props.calculateTotal(optionFeeTypeId, optionAmount, props.netAcres, props.measurementTypes);
                props.setValue(`${props.namePrefix}[${index}].optionTotal`, totalRent);
            }
        }
    };

    if (props.extensionOptions?.length > 0) {
        return (
            <div>
                {props.extensionOptions.map((extension: ExtensionOption, index: number) => {
                    return (
                        <div className="form-row" key={`extension-${index}`}>
                            <div className="mr-1" hidden={true}>
                                <RHFInputBox label="" name={`${props.namePrefix}[${index}].id`} register={props.register} errors={props.errors} disabled={true} />
                            </div>
                            <RHFInputBox
                                label="Option Term"
                                name={`${props.namePrefix}[${index}].optionTerm`}
                                register={props.register}
                                type="number"
                                errors={props.errors}
                                disabled={props.isReadonly}
                            />
                            <RHFSelect
                                label=" "
                                name={`${props.namePrefix}[${index}].optionUnitTypeId`}
                                options={AgreementUtil.getOptions(props.measurementTypes, 'Time')}
                                register={props.register}
                                errors={props.errors}
                                disabled={props.isReadonly}
                            />

                            <RHFInputBox
                                label="Option Amount"
                                name={`${props.namePrefix}[${index}].optionAmount`}
                                register={props.register}
                                type="number"
                                errors={props.errors}
                                onChange={() => handleTotals(index)}
                                step={0.0001}
                                disabled={props.isReadonly}
                            />
                            <RHFSelect
                                label=" "
                                name={`${props.namePrefix}[${index}].optionFeeTypeId`}
                                options={AgreementUtil.getOptions(props.measurementTypes, 'Fee', 'acre')}
                                onChange={() => handleTotals(index)}
                                register={props.register}
                                errors={props.errors}
                                disabled={props.isReadonly}
                            />
                            <RHFInputBox
                                label="Option Total"
                                name={`${props.namePrefix}[${index}].optionTotal`}
                                register={props.register}
                                type="number"
                                errors={props.errors}
                                disabled={props.calculateTotals === true || props.isReadonly}
                                step={0.0001}
                            />
                            <RHFCheckbox
                                label="Prepaid Option"
                                name={`${props.namePrefix}[${index}].prepaidOption`}
                                register={props.register}
                                errors={props.errors}
                            />
                        </div>
                    );
                })}
            </div>
        );
    }
    return <div />;
};

export default ExtensionOptionList;


// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/ExtensionOptionList.tsx